import { StarMinusIcon } from './StarMinusIcon';

/**
 * author: Michael Irigoyen
 * id CA24758C-3B0C-44DE-9395-C5CAF2981E5D
 * name star-minus
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-minus.svg
 * tags
 * - Shape 
 */
export const FavoriteMinusIcon = StarMinusIcon;
export default FavoriteMinusIcon